module.exports = __webpack_public_path__ + "static/media/image-thumb-3.395da1f6.jpeg";